import { Pill } from '#components/atoms/pill/Pill.tsx';

type Props = {
  label: string;
  variant?: 'default' | 'alert' | 'success';
  className?: string;
  ref?: React.Ref<HTMLSpanElement>;
};

export function TagPill({ label, variant, className, ref }: Props) {
  return (
    <Pill size="small" variant={variant} className={className} ref={ref}>
      {label}
    </Pill>
  );
}
